module.exports = __webpack_public_path__ + "static/media/attachIconAnonymous.04fea262.svg";